import { Toast as BaseToast } from '@base-ui/react/toast';

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import { toastBadgeVariants, toastDotVariants } from '../Toast/Toast.variants';

import type { TToastItemProps } from './ToastItem.props';

const ROOT = cn(
  'bg-surface border-border rounded-lg shadow-modal flex w-full items-center gap-3 border py-3 pr-4 pl-3',
  'transition-all duration-200 ease-out',
  'data-starting-style:-translate-y-2 data-starting-style:opacity-0',
  'data-ending-style:-translate-y-2 data-ending-style:opacity-0',
);

const resolveVariant = (type?: string) => {
  if (type === 'success' || type === 'error') {
    return type;
  }

  return 'info';
};

const ToastItem: FC<TToastItemProps> = ({ toast }) => {
  const variant = resolveVariant(toast.type);

  return (
    <BaseToast.Root toast={toast} className={ROOT}>
      <span aria-hidden className={toastBadgeVariants({ variant })}>
        <span className={toastDotVariants({ variant })} />
      </span>
      <BaseToast.Title className="text-body text-text-primary min-w-0 flex-1 truncate" />
    </BaseToast.Root>
  );
};

export {
  ToastItem,
};
